module.exports = __webpack_public_path__ + "static/img/plan2.788d1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/clix/training-plan/plan2.png
// module id = pA5V
// module chunks = 35